/**
 * Toast notification system
 */

import { useEffect } from "preact/hooks";

export interface ToastMessage {
  id: string;
  message: string;
  type: "success" | "error" | "info" | "undo";
  duration?: number;
  onUndo?: () => void;
}

interface ToastProps {
  toasts: ToastMessage[];
  onDismiss: (id: string) => void;
}

export function ToastContainer({ toasts, onDismiss }: ToastProps) {
  return (
    <div class="toast-container">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}

interface SingleToastProps {
  toast: ToastMessage;
  onDismiss: (id: string) => void;
}

function Toast({ toast, onDismiss }: SingleToastProps) {
  useEffect(() => {
    if (toast.type !== "undo") {
      const timer = setTimeout(() => {
        onDismiss(toast.id);
      }, toast.duration ?? 3000);
      return () => clearTimeout(timer);
    }
  }, [toast.id, toast.duration, toast.type, onDismiss]);

  return (
    <div class={`toast toast-${toast.type}`}>
      <span class="toast-message">{toast.message}</span>
      {toast.type === "undo" && toast.onUndo && (
        <button
          class="toast-undo-btn"
          onClick={() => {
            toast.onUndo?.();
            onDismiss(toast.id);
          }}
        >
          Undo
        </button>
      )}
      <button class="toast-close" onClick={() => onDismiss(toast.id)}>
        ×
      </button>
    </div>
  );
}
